import Actions from 'flow/actions';

// Events sent to the web app from the host system.
export const INCOMING_EVENTS = {
    CONTACT_DECORATIONS_RESPONSE: 'CONTACT_DECORATIONS_RESPONSE',
    REGISTER_ORIGIN: 'REGISTER_ORIGIN',
    FEATURE_FLAGS: 'FEATURE_FLAGS',
    DIAL_NUMBER: 'DIAL_NUMBER',
    PROXY_REQUEST: 'PROXY_REQUEST',
};

// Events sent to the host system from the web app.
export const OUTGOING_EVENTS = {
    GET_CONTACT_DECORATIONS: 'GET_CONTACT_DECORATIONS',
    PARENT_ROUTE_REQUEST: 'PARENT_ROUTE_REQUEST',
    CALL_LOG: 'CALL_LOG',
    USER_LOGGED_IN: 'USER_LOGGED_IN',
    USER_LOGGED_OUT: 'USER_LOGGED_OUT',
    INCOMING_CALL: 'INCOMING_CALL',
    CALL_ENDED: 'CALL_ENDED',
    OUTGOING_CALL_STARTED: 'OUTGOING_CALL_STARTED',
    CALL_ANSWERED: 'CALL_ANSWERED',
    PROXY_REQUEST_RESPONSE: 'PROXY_REQUEST_RESPONSE',
};

// Incoming events that map to actions in our reducer.
// We need this map since actions are ENUMs, and the
// Telavox CTI postMessage API uses strings.
const CTI_STRING_TO_ACTION_MAP = {};
CTI_STRING_TO_ACTION_MAP[INCOMING_EVENTS.REGISTER_ORIGIN] =
    Actions.CTI_REGISTER_ORIGIN;
CTI_STRING_TO_ACTION_MAP[INCOMING_EVENTS.CONTACT_DECORATIONS_RESPONSE] =
    Actions.CTI_RESULT_CONTACT_DECORATIONS;
CTI_STRING_TO_ACTION_MAP[INCOMING_EVENTS.FEATURE_FLAGS] =
    Actions.CTI_FEATURE_FLAGS;
CTI_STRING_TO_ACTION_MAP[INCOMING_EVENTS.AUTH_REQUIRED] =
    Actions.CTI_AUTH_REQUIRED;

export const getActionFromIncomingEvent = (eventTypeAsString) => {
    return CTI_STRING_TO_ACTION_MAP[eventTypeAsString];
};

export const INCOMING_POSTMESSAGE_API_FORMAT = 'Incoming';
export const OUTGOING_POSTMESSAGE_API_FORMAT = 'Outgoing';
